import { useStore } from 'zustand';

import { Button } from '@/components/ui/button/button.component';
import { StepKeys } from '@/app/(main)/_components/sign-in-modal/_types/header-auth-modal-step-keys.enum';
import { passwordRecoveryStore } from '@/store/login.store';
import { useProgressiveModal } from '@/components/ui/progressive-modal/progressive-modal.hook';
import { Typography } from '@/components/ui/typography/typography.component';
import { TypographyVariant } from '@/components/ui/typography/typography.type';
import { patientSacWhatsappMessage } from '@/utils/consts/cta-whatsapp-messages.consts';
import { useWhatsappLinkSimple } from '@/hooks/use-whatsapp/use-whatsapp-link-simple.hook';
import { phonePatientSac, visualPhonePatientSac } from '@/utils/consts/sac.consts';
import { Link } from '@/components/ui/link/link.component';

export const ForgotPassword = () => {
  const recoveryEmail = useStore(passwordRecoveryStore, (state) => state.recoveryEmail);
  const { url } = useWhatsappLinkSimple(
    phonePatientSac,
    patientSacWhatsappMessage,
  );
  const { handleJump: jump } = useProgressiveModal<StepKeys>();

  return (
    <div>
      <Typography variant={TypographyVariant.BODY_TEXT} className="mb-4">
        Enviamos um e-mail para
        {' '}
        <span className="font-semibold text-base">{recoveryEmail}</span>
        {' '}
        com instruções para criar uma
        nova senha.
      </Typography>
      <Typography variant={TypographyVariant.BODY_TEXT} className="text-gray-700 font-bold">
        Não tem mais acesso ao e-mail?
      </Typography>
      <Typography>
        Fale com o atendimento pelo WhatsaApp
        {' '}
        <Link href={url} className="text-green-500 font-bold" target="_blank">{visualPhonePatientSac}</Link>
      </Typography>
      <Button
        variant="default"
        color="primary"
        className="mt-6 text-xl"
        onClick={() => {
          jump({ key: StepKeys.LOGIN, returning: true });
        }}
      >
        Entendi
      </Button>
    </div>
  );
};
